import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { NonDispatchableMarketplaces } from './NonDispatchableMarketplaces';

export const MarketplaceSupportsMarkingAsDispatched = (x: SmartSendItemApiModel) => {
  return !x.MarketplaceOrderLines.every((x) => NonDispatchableMarketplaces.includes(x.Source?.Id));
};
